
namespace TabAurous.Retail {

  
    @Serenity.Decorators.registerClass()
    export class POSOrderItemsSelectGrid extends _Ext.GridBase<POSOrderItemsRow, any> {
        protected getColumnsKey() { return 'Retail.OrderItems'; }
        protected getDialogType() { return POSOrderItemsDialog; }
        protected getIdProperty() { return POSOrderItemsRow.idProperty; }
        protected getInsertPermission() { return POSOrderItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return POSOrderItemsRow.localTextPrefix; }
        protected getService() { return POSOrderItemsForInvoiceService.baseUrl; }

        private autoSize;
        private pendingChanges: Q.Dictionary<any> = {}; 
        withBom: boolean;
       
        //withBom: boolean;
        constructor(container: JQuery, options) {
            super(container, options);
            (this.view.params as TransactionRequest).POSCustomerId = options.GridFilters.CustomerId;
            (this.view.params as TransactionRequest).InStock = options.GridFilters.InStock;
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        get selectedItems(): POSOrderItemsRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        //private getEffectiveValue(item, field): any {
        //    var pending = this.pendingChanges[item.ProductID];
        //    if (pending && pending[field] !== undefined) {
        //        return pending[field];
        //    }

        //    return item[field];
        //}

        protected getViewOptions() {
            var opt = super.getViewOptions();

            opt.rowsPerPage = 100;
            return opt;
        }

    } 
}